import { render, staticRenderFns } from "./workCreate.vue?vue&type=template&id=e3540fa4&scoped=true"
import script from "./workCreate.vue?vue&type=script&lang=js"
export * from "./workCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3540fa4",
  null
  
)

export default component.exports